module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "plano_modal"
  }, [_c('b-card', [_c('label', [_c('h3', [_vm._v("Edit Shelf")])]), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Fixed:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.fixed),
      callback: function($$v) {
        _vm.fixed = $$v
      },
      expression: "fixed"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Label:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('b-form-input', {
    model: {
      value: (_vm.labelText),
      callback: function($$v) {
        _vm.labelText = $$v
      },
      expression: "labelText"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Bottom Adhesive:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.bottomAdhesive),
      callback: function($$v) {
        _vm.bottomAdhesive = $$v
      },
      expression: "bottomAdhesive"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-button-toolbar', [_c('b-button', {
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.validate();
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "margin": "5px"
    },
    on: {
      "click": function($event) {
        _vm.cancel();
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37a030ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/edits/edit_board_shelf.vue
// module id = 3122
// module chunks = 0